// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"b157ea50","297":"4ca71e98","643":"05b263cc"}[chunkId] + ".chunk.js";
};